import React, { useState } from 'react';
import { StackShim as Stack, StackItemShim as StackItem } from '@fluentui/react-migration-v8-v9';
import { Button, Field, Spinner, Textarea } from '@fluentui/react-components';
import { useMutation } from '@apollo/client';
import { IMilestoneListActionItemProps, MilestoneActionType } from '../Interfaces';
import LoadingErrorMessage from '../../../common/errorContent/LoadingErrorMessage';
import { RESCIND_MILESTONE_MUTATION } from '../../../../utils/statApi/MilestoneApi';
import milestoneListItemActionWrapper from '../processStyles';

const buttonSpinnerStyles = { marginRight: 5 };

const rescindRequiredText = 'A reason for rescinding is required';
const isRescindingText = 'Rescinding the milestone';
const rescindTextFieldLabel = 'Please provide a reason for rescinding this milestone:';
const ariaReasonForRescindLabel = 'Reason for Rescind';

const MilestoneSignoffAction = ({
  milestone,
  submit,
}: IMilestoneListActionItemProps): JSX.Element => {
  const [missingRescindError, setMissingRescindError] = useState('');
  const [comments, setComments] = useState('');
  const isMissingComments = !comments || comments.length === 0;

  const [updateMilestone, { loading, error }] = useMutation(RESCIND_MILESTONE_MUTATION, {
    onCompleted: () => {
      submit(MilestoneActionType.normal);
    },
  });

  const submitMilestoneAction = (): void => {
    updateMilestone({ variables: { milestoneId: milestone.id, comments } });
  };

  return (
    <Stack horizontalAlign="center">
      <LoadingErrorMessage error={error} loading={loading} actionName={isRescindingText} />
      <StackItem className={milestoneListItemActionWrapper}>
        <Field label={rescindTextFieldLabel} required validationMessage={missingRescindError}>
          <Textarea
            aria-label={ariaReasonForRescindLabel}
            resize="none"
            value={comments}
            onChange={(e, data): void => {
              setComments(data.value);
            }}
            onBlur={(): void => {
              setMissingRescindError(isMissingComments && rescindRequiredText);
            }}
          />
        </Field>
      </StackItem>
      <Button
        appearance="primary"
        onClick={submitMilestoneAction}
        disabled={loading || isMissingComments}
      >
        {loading && <Spinner size="tiny" style={buttonSpinnerStyles} aria-label="Loading" />}
        Submit
      </Button>
    </Stack>
  );
};

export default MilestoneSignoffAction;
